export default __webpack_public_path__ + "static/media/480_business03-jp-mobile.8f97097f.png";